import { render, staticRenderFns } from "./Gains.vue?vue&type=template&id=afd4b34a&"
import script from "./Gains.vue?vue&type=script&lang=js&"
export * from "./Gains.vue?vue&type=script&lang=js&"
import style0 from "./Gains.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports